import * as React from 'react';

import { Button, Paper, Stack, InputBase, Chip, Popover, Icon, Modal, Box } from "@mui/material";
import { List, ListItemButton } from "@mui/material";
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import WhatshotRoundedIcon from '@mui/icons-material/WhatshotRounded';
import ArrowCircleUpRoundedIcon from '@mui/icons-material/ArrowCircleUpRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import EmojiPicker from 'emoji-picker-react';

function EnterCheckin(props) {
    const { user, refreshCheckins } = props;
    const [checkinTextValue, setCheckinTextValue] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popoverContent, setPopoverContent] = React.useState(null);
    const [requiredData, setRequiredData] = React.useState(false);
    const [category, setCategory] = React.useState(null);

    const [newCategoryEmoji, setNewCategoryEmoji] = React.useState("🤷‍♂️");
    const [newCategoryName, setNewCategoryName] = React.useState("");

    const [inputActive, setInputActive] = React.useState(false);

    const [createCategoryModalOpen, setCreateCategoryModalOpen] = React.useState(false);

    function postCheckin() {
        const checkin = checkinTextValue;
        if (!checkin || checkin.length === 0) {
            return;
        }

        setLoading(true);
        setCheckinTextValue("");

        const myHeaders = new Headers();
        myHeaders.append("x-functions-key", "0VHZP7epS5k1mMi9TOUP65WfCCu-VzzcFzi7TEkZHLpOAzFuccq_uQ==");
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "text": checkin,
            "user_id": user.sub
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://api-ember.azurewebsites.net/api/checkin", requestOptions)
            .then(response => response.text())
            .then(result => {
                setLoading(false);
                refreshCheckins();
            })
            .catch(error => console.log('error', error));

    }

    const handleCheckinTextChange = (event) => {
        const checkin = event.target.value;
        setCheckinTextValue(checkin);
        setRequiredData(checkin.trim().length > 0);
    }

    const handleModalOpen = () => {
        setCreateCategoryModalOpen(true);
        handleChipClose();
    }

    const handleModalClose = () => {
        setCreateCategoryModalOpen(false);
    }

    const handleChipClick = (event) => {
        if (event.currentTarget.id === "category-chip") {
            setCategoryPopoverContent();
        } else if (event.currentTarget.id === "date-chip") {
            setDatePopoverContent();
        }

        setAnchorEl(event.currentTarget);
    }

    const handleChipClose = () => {
        setAnchorEl(null);
    }

    const handleEmojiSelect = (event) => {
        setEmojiPopoverContent();
        setAnchorEl(event.currentTarget);
    }

    const handleCreateNewCategory = () => {
        const category = {
            emoji: newCategoryEmoji,
            name: newCategoryName,
            new: true
        }

        setCreateCategoryModalOpen(false);
        setCategory(category);
    }

    const setEmojiPopoverContent = () => {
        setPopoverContent(
            <EmojiPicker
                previewConfig={{ showPreview: false }}
                onEmojiClick={(emojiData, event) => {
                    setNewCategoryEmoji(emojiData.emoji);
                    handleChipClose();
                }}
            />
        );
    }

    const setCategoryPopoverContent = () => {
        const categories = [];
        setPopoverContent(
            <List>
                {categories.map((option) =>
                    <ListItemButton key={option}>
                        <span className='app-font'>{option}</span>
                    </ListItemButton>
                )}
                <ListItemButton
                    onClick={handleModalOpen}
                >
                    {/* <AddRoundedIcon size="small" sx={{paddingRight: "5px", marginLeft:"-7px"}}/> */} {/* TODO */}
                    <span className='app-font'>Create a new category</span>
                </ListItemButton>
            </List>
        );
    }

    const setDatePopoverContent = () => {
        const options = ['Today', 'Yesterday', '2 Days Ago', 'Last Week', 'Custom'];
        setPopoverContent(
            <List>
                {options.map((option) => (
                    <ListItemButton key={option}>
                        <span className='app-font'>{option}</span>
                    </ListItemButton>
                ))}
            </List>
        );
    }

    return (
        <div>
            <Paper
                elevation={0}
                sx={{
                    padding: 1.5,
                    paddingLeft: 3,
                    paddingBottom: 2,
                    paddingRight: 3,
                    borderRadius: 2.5,
                    border: '1px solid #F0ECF0',
                    // background: '#FAF6FA',
                    background: inputActive ? "white" : "#FAF6FA",
                    transition: "all .5s ease",
                    WebkitTransition: "all .5s ease",
                    MozTransition: "all .5s ease",  
                }}

            >
                <Stack direction="column" spacing={1}>
                    <Stack direction="row" spacing={1}>
                        <InputBase
                            multiline
                            onFocus={() => setInputActive(true)}
                            onBlur={() => setInputActive(false)}
                            placeholder="What did you do today?"
                            fullWidth
                            value={checkinTextValue}
                            onChange={handleCheckinTextChange}
                        />
                        <Button
                            disabled={loading | !requiredData}
                            variant="contained"
                            style={{ backgroundColor: (loading | !requiredData) ? "#fffbff" : "#3f0300", height: "40px", borderRadius: "20px", width: "20px" }}
                            onClick={postCheckin}
                        >
                            <ArrowUpwardRoundedIcon />
                        </Button>
                    </Stack>
                    {/* <Stack direction="row" spacing={1}>
                        {/* <Chip
                            id="category-chip"
                            className="app-font"
                            icon={ category ? <Icon fontSize='small' style={{marginTop: '-5px'}}>{category.emoji}</Icon> : <CategoryRoundedIcon fontSize='small' /> }
                            label={ <span className='app-font' style={{ padding: "0px 3px" }}> {category ? category.name : "Select a category"} </span> }
                            style={{ background: "white", padding: "0px 5px", color: "black" }}
                            size="medium"
                            variant='outlined'
                            clickable
                            onClick={handleChipClick}
                        /> */}
                        {/* <Chip
                            id="date-chip"
                            className="app-font"
                            icon={<CalendarTodayRoundedIcon fontSize='small' />}
                            // icon={<Icon fontSize='small' style={{marginTop: '-5px'}}>🤷‍♂️</Icon>}
                            label={<span className='app-font'>Today</span>}
                            style={{ background: "white", padding: "0px 5px", color: "black" }}
                            size="medium"
                            variant='outlined'
                            clickable
                            onClick={handleChipClick}
                        /> */}
{/* 
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleChipClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            {popoverContent}
                        </Popover> */}
                    {/* </Stack> */} 
                </Stack>
            </Paper>
            <Modal
                open={createCategoryModalOpen}
                onClose={handleModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Box sx={
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: '10px',
                        boxShadow: 10,
                        p: 4,
                    }
                }>
                    <Stack
                        direction={'column'}
                        alignItems={'center'}
                        spacing={2}
                    >
                        <Button
                            style={{ width: "90px", height: "60px" }}
                            onClick={handleEmojiSelect}
                        >
                            <span style={{ fontSize: "36px" }}>{newCategoryEmoji}</span>
                        </Button>
                        <InputBase
                            placeholder="Create a new category"
                            value={newCategoryName}
                            onChange={(event) => setNewCategoryName(event.target.value)}
                            style={{ textAlign: "center", fontSize: "24px" }}
                            fullWidth
                        />
                        <Button
                            variant='contained'
                            style={{ backgroundColor: (false) ? "#fffbff" : "#3f0300", maxHeight: "40px", borderRadius: "20px", padding: "10px 40px" }}
                            onClick={handleCreateNewCategory}
                        >
                            <span className='app-font'>Create</span>
                        </Button>
                    </Stack>
                </Box>
            </Modal>
            <br /><br />
        </div>
    )
}

export { EnterCheckin };